import { useAccessor } from 'typed-vuex'

import { pattern, store } from './store'

export const accessor = useAccessor(store, pattern)

export type Accessor = typeof accessor
